<template>
  <nav class="mega-menu mega-menu--resources" data-gtm-context="Resources Menu">
    <ul class="mega-menu__list">
      <li>
        <a class="mega-menu__item" href="/support/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m4.93 4.93 4.24 4.24"/><path d="m14.83 9.17 4.24-4.24"/><path d="m14.83 14.83 4.24 4.24"/><path d="m9.17 14.83-4.24 4.24"/><circle cx="12" cy="12" r="4"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Support</h6>
            <p class="mega-menu__description">Search our extensive library</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/marketing-glossary/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Marketing Glossary</h6>
            <p class="mega-menu__description">Plain-English definitions, A&ndash;Z</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/videos/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Videos</h6>
            <p class="mega-menu__description">Guides, walkthroughs &amp; webinars</p>
          </div>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "ResourcesMenu",
};
</script>
